<template>
    <div>
        <base-page-header :breadcrumb="breadcrumb" title=""/>
        <h1>{{egarNum}}</h1>
        <h3>{{egarCode}}</h3>

        <v-row class="bg-white mt-3" v-if="dados.sender">
            <v-col cols="12">
                <div class="btn-close" @click="backPage">
                    <img src="/images/_SVGs/environmental/fechar.svg" alt="fechar" onload="SVGInject(this)" width="30" height="30" />
                </div>
            </v-col>

            <v-col cols="12" sm="10">
                <v-row>
                    <v-col cols="12" sm="8">
                        <h3>{{$t('environmental-management.egar.edit-egar-form.operator-h3')}}</h3>
                        <p class="title_">
                            {{dados.recipient.nif}} - {{dados.recipient.name}}
                        </p>
                        <p class="subTitle">
                            {{dados.recipient.establishment.apaCode}} - {{dados.recipient.establishment.establishmentName}}
                        </p>
                    </v-col>

                    <v-col cols="12" sm="4">
                        <h3>{{$t('environmental-management.egar.edit-egar-form.status-h3')}}</h3>
                        <div class="pendente" v-if="dados.statusCode == 'AA'">
                            <img src="/images/_SVGs/environmental/pendente.svg" alt="Status" class="mr-3" onload="SVGInject(this)" width="15" height="15" />
                            {{$t('environmental-management.egar.status-icon.pendent')}}
                        </div>
                        <div class="emidita" v-if="dados.statusCode == 'EM'">
                            <img src="/images/_SVGs/environmental/emitir.svg" alt="Status" class="mr-3" onload="SVGInject(this)" width="15" height="15" />
                            {{$t('environmental-management.egar.status-icon.emitt')}}
                        </div>
                        <div class="anulada" v-if="dados.statusCode == 'AN'">
                            <img src="/images/_SVGs/environmental/anular.svg" alt="Status" class="mr-3" onload="SVGInject(this)" width="15" height="15" />
                            {{$t('environmental-management.egar.status-icon.canceled')}}
                        </div>
                        <div class="concluir" v-if="dados.statusCode == 'CC'">
                            <img src="/images/_SVGs/environmental/check.svg" alt="Status" class="mr-3" onload="SVGInject(this)" width="15" height="15" />
                            {{$t('environmental-management.egar.status-icon.finish')}}
                        </div>
                        <div class="concluir" v-if="dados.statusCode == 'AC'">
                            <img src="/images/_SVGs/environmental/check.svg" alt="Status" class="mr-3" onload="SVGInject(this)" width="15" height="15" />
                            {{$t('environmental-management.egar.status-icon.accpeted')}}
                        </div>
                        <div class="corrigido" v-if="dados.statusCode == 'CO'">
                            <img src="/images/_SVGs/environmental/corrigir.svg" alt="Status" class="mr-3" onload="SVGInject(this)" width="15" height="15" />
                            {{$t('environmental-management.egar.status-icon.adjusted')}}
                        </div>
                        <div class="anulada" v-if="dados.statusCode == 'RJ'">
                            <img src="/images/_SVGs/environmental/anular.svg" alt="Status" class="mr-3" onload="SVGInject(this)" width="15" height="15" />
                            {{$t('environmental-management.egar.status-icon.rejected')}}
                        </div>

                        <div class="anulada" v-if="dados.statusCode == 'CN'">
                            <img src="/images/_SVGs/environmental/anular.svg" alt="Status" class="mr-3" onload="SVGInject(this)" width="15" height="15" />
                            {{$t('environmental-management.egar.status-icon.correction-denied')}}
                        </div>

                    </v-col>

                    <v-col cols="12" sm="8">
                        <h3>{{$t('environmental-management.egar.edit-egar-form.transporter')}}</h3>

                        <div class="div-transp">
                            <p class="title_">
                                <b>{{$t('environmental-management.egar.edit-egar-form.plate')}}</b>
                                {{dados.transporters.plateNumber}}
                            </p>
                            <p class="title_">
                                {{dados.transporters.nif}}
                                -
                                {{dados.transporters.name}}
                            </p>
                            <!--<p class="subTitle mb-0">
                                APA00039407 - Carriço
                            </p>-->
                        </div>
                    </v-col>

                    <v-col cols="12" sm="4">
                        <h3>{{$t('environmental-management.egar.edit-egar-form.date-transporter')}}</h3>
                        <p class="title_">
                            {{dados.transporters.transportationStartDateTime | formatOnlyDate}}
                        </p>
                        <p class="title_">
                            {{dados.transporters.transportationStartDateTime | formatTimeOld}}
                        </p>
                    </v-col>
                </v-row>
            </v-col>

            <v-col cols="12" sm="2">
                <v-row class="menu-action">
                    <v-col cols="12" class="p-1">
                        <a class="cursor-pointer" @click="duplicarItem()">
                            <img src="/images/_SVGs/environmental/duplicate.svg" :alt="$t('environmental-management.egar.duplicate')" class="mr-3" onload="SVGInject(this)" width="15" height="15" />
                            {{$t('environmental-management.egar.duplicate')}}
                        </a>
                    </v-col>
                    <v-col cols="12" class="p-1" v-if="dados.statusCode != 'AN'">
                        <a :href="dados.url" target="_blank">
                            <img src="/images/_SVGs/environmental/download-button.svg" :alt="$t('environmental-management.egar.download')" class="mr-3" onload="SVGInject(this)" width="15" height="15" />
                            {{$t('environmental-management.egar.download')}}
                        </a>
                    </v-col>
                    <v-col cols="12" class="p-1" v-if="dados.statusCode != 'AN'">
                        <a class="cursor-pointer" @click="showModalEmail(dados)">
                            <img src="/images/_SVGs/environmental/email.svg" :alt="$t('environmental-management.egar.email')" class="mr-3" onload="SVGInject(this)" width="15" height="15" />
                            {{$t('environmental-management.egar.email')}}
                        </a>
                    </v-col>
                    <v-col cols="12" class="p-1" v-if="(dados.statusCode == 'EM' && !isProducer) || (dados.statusCode == 'CN' && !isProducer) ">
                        <a class="cursor-pointer" @click="corrigirShow()">
                            <img src="/images/_SVGs/environmental/corrigir.svg" :alt="$t('environmental-management.egar.correct')" class="mr-3" onload="SVGInject(this)" width="15" height="15" />
                            {{$t('environmental-management.egar.correct')}}
                        </a>
                    </v-col>

                    <v-col cols="12" class="p-1" v-if="(dados.statusCode == 'EM' && !isProducer) || (dados.statusCode == 'CN' && !isProducer)">
                        <a class="cursor-pointer" @click="showModalAccept()">
                            <img src="/images/_SVGs/environmental/check.svg" :alt="$t('environmental-management.egar.accept')" class="mr-3" onload="SVGInject(this)" width="15" height="15" />
                            {{$t('environmental-management.egar.accept')}}
                        </a>
                    </v-col>

                    <v-col cols="12" class="p-1" v-if="(dados.statusCode == 'EM' && !isProducer) || (dados.statusCode == 'CN' && !isProducer)">
                        <a class="cursor-pointer" @click="showModalReject()">
                            <img src="/images/_SVGs/environmental/anular.svg" :alt="$t('environmental-management.egar.reject')" class="mr-3" onload="SVGInject(this)" width="15" height="15" />
                            {{$t('environmental-management.egar.reject')}}
                        </a>
                    </v-col>

                    <v-col cols="12" class="p-1" v-if="dados.statusCode == 'EM'">
                        <a class="cursor-pointer" @click="showModalAnular()">
                            <img src="/images/_SVGs/environmental/anular.svg" :alt="$t('environmental-management.egar.annul')" class="mr-3" onload="SVGInject(this)" width="15" height="15" />
                            {{$t('environmental-management.egar.annul')}}
                        </a>
                    </v-col>

                    <v-col cols="12" class="p-1" v-if="dados.statusCode == 'CO' && isProducer">
                        <a class="cursor-pointer" @click="acceptCorrectionSend()">
                            <img src="/images/_SVGs/environmental/check.svg" :alt="$t('environmental-management.egar.accept-correction')" class="mr-3" onload="SVGInject(this)" width="15" height="15" />
                            {{$t('environmental-management.egar.accept-correction')}}
                        </a>
                    </v-col>

                    <v-col cols="12" class="p-1" v-if="dados.statusCode == 'CO' && isProducer">
                        <a class="cursor-pointer" @click="showModalRejectCorrection()">
                            <img src="/images/_SVGs/environmental/anular.svg" :alt="$t('environmental-management.egar.reject-correction')" class="mr-3" onload="SVGInject(this)" width="15" height="15" />
                            {{$t('environmental-management.egar.reject-correction')}}
                        </a>
                    </v-col>

                    <v-col cols="12" class="p-1" v-if="dados.statusCode == 'RJ' && isProducer">
                        <a class="cursor-pointer" @click="showModalAssociate()">
                            <img src="/images/_SVGs/environmental/check.svg" :alt="$t('environmental-management.egar.partner')" class="mr-3" onload="SVGInject(this)" width="15" height="15" />
                            {{$t('environmental-management.egar.partner')}}
                        </a>
                    </v-col>

                    <v-col cols="12" class="p-1" v-if="dados.statusCode == 'AC' && isProducer || dados.statusCode == 'CO' && isProducer && dados.pendingAuthorization">
                      <a class="cursor-pointer" @click="sendAuthorizeEgar()">
                          <img src="/images/_SVGs/environmental/check.svg" :alt="$t('environmental-management.egar.partner')" class="mr-3" onload="SVGInject(this)" width="15" height="15" />
                          {{$t('environmental-management.egar.authorize')}}
                      </a>
                    </v-col>
                </v-row>
            </v-col>

            <v-col cols="12">
                <div class="div-produtor">
                    <p class="title_">
                        <b>{{$t('environmental-management.egar.edit-egar-form.adress')}} </b>{{dados.sender.address}} {{dados.sender.locality}} {{dados.sender.postalCode}}
                    </p>
                    <p class="title_">
                        {{dados.sender.nif}} - {{dados.sender.name}}
                    </p>
                    <p class="subTitle mb-0">
                        {{dados.sender.establishment.apaCode}} - {{dados.sender.establishment.establishmentName}}
                    </p>
                </div>
            </v-col>

            <v-col cols="12" >
                <v-form v-model="form.isValid">
                    <v-row>
                        <v-col cols="12" sm="5">
                            <p class="title_">
                                <b>{{$t('environmental-management.egar.edit-egar-form.ler-residue')}}</b>
                            </p>
                            <div v-if="!corrigir">
                                <p class="title_">
                                    {{ dados.tranportedResidue.operationDescription}}
                                </p>
                                <p class="subTitle mb-0" v-if="!corrigir">
                                    {{dados.tranportedResidue.residueLerCode}} - {{ dados.tranportedResidue.residueDescription.substr(0, 50)}}...
                                </p>
                            </div>
                            <div v-else>
                                <span>-</span>

                                <v-select
                                    :items="lerCodes.length > 0? lerCodes.map(el => ({text: el.lerCode + ' - ' + el.description, value: el.lerCode})) : []"
                                    :rules="formInputs.default.rules"
                                    filled
                                    @change="getOperationCodes(form.lerCode)"
                                    v-model="form.lerCode"
                                    hide-details="auto"
                                    :label="$t('environmental-management.egar.edit-egar-form.ler-code-req-label')"
                                    :menu-props="{ top: false, offsetY: true }"
                                ></v-select>
                            </div>
                        </v-col>

                        <v-col cols="12" sm="3">
                            <p class="title_">
                                <b>{{$t('environmental-management.egar.edit-egar-form.operation-code')}}</b>
                            </p>
                            <p class="title_">
                                <span v-if="corrigir">-</span>
                                <span v-else>{{dados.tranportedResidue.operationCode}} - {{dados.tranportedResidue.operationDescription}}</span>
                            </p>
                                <v-select
                                :items="operationCodes.length > 0? operationCodes.map(el => ({text: el.operationCode + ' - ' + el.containerType ,value: el.operationCode})) : []"
                                v-model="form.operationCode"
                                v-if="corrigir"
                                :rules="formInputs.default.rules"
                                filled
                                hide-details="auto"
                                :label="$t('environmental-management.egar.edit-egar-form.operation-code-req-label')"
                                :menu-props="{ top: false, offsetY: true }"
                                ></v-select>
                        </v-col>

                        <v-col cols="12" sm="2">
                            <p class="title_">
                                <b>{{$t('environmental-management.egar.edit-egar-form.original-qtd')}}</b>
                            </p>
                            <p class="title_">
                                <span v-if="corrigir">-</span>
                                <span v-else>{{dados.tranportedResidue.quantity}} Kg</span>
                            </p>

                            <v-text-field
                                filled
                                :value="dados.tranportedResidue.quantity"
                                disabled
                                :label="$t('environmental-management.egar.edit-egar-form.qtd-kg-label')"
                                v-if="corrigir"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="2">
                            <p class="title_">
                                <b>{{$t('environmental-management.egar.edit-egar-form.qtd-correct')}}</b>
                            </p>
                            <p class="title_">
                                <span v-if="corrigir">-</span>
                                <span v-else> {{dados.correctedTransportedResidue.correctedQuantity?  dados.correctedTransportedResidue.correctedQuantity : '-'}} Kg</span>
                            </p>

                            <v-text-field
                                :label="$t('environmental-management.egar.edit-egar-form.qtd-kg-label')"
                                filled
                                @keypress="onlyNumberRule"
                                v-model="form.qtd"
                                :rules="formInputs.default.rules"
                                v-if="corrigir"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row class="mt-4" v-if="corrigir">
                        <v-col cols="12" class="text-center">
                            <v-btn class="success" :disabled="!form.isValid" @click="corrigirSend()">
                                {{$t('save')}}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </v-col>
        </v-row>

        <base-modal v-model="modalAlert.show" :title="$t('heads-up')" modal-width="560px" >
            <template v-slot:modal-close>
                <div @click="backPage()">
                    <img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" width="20" height="20" />
                </div>
            </template>

            <template v-slot:modal-body>
                {{modalAlert.msg}}
            </template>

            <template v-slot:modal-actions>
                <div>
                    <v-btn class="primary-button" text @click="backPage()">
                        {{$t('ok')}}
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <!-- Modal Cancel Egar. -->
        <base-modal v-model="modalAnularEgar.show" modalAlign="align__flex--center" :title="$t('environmental-management.egar.edit-egar-form.modal-annul-egar.title')" modal-width="460px">
            <template v-slot:modal-close>
                <div @click="modalAnularEgar.show = false">
                    <img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" width="20" height="20" />
                </div>
            </template>

            <template v-slot:modal-body>
                <p>{{$t('environmental-management.egar.edit-egar-form.modal-annul-egar.msg')}}</p>

                <v-text-field
                    filled
                    v-model="modalAnularEgar.obs"
                    :label="$t('environmental-management.egar.edit-egar-form.obs-label')"
                ></v-text-field>
            </template>


            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn text class="danger-button"  @click="modalAnularEgar.show = false">
                        <span style="text-transform: capitalize">{{$t('no')}}</span>
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn text class="primary-button" @click="anularSend()">
                        <span style="text-transform: capitalize">{{$t('yes')}}</span>
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <!-- Modal Reject Egar. -->
        <base-modal v-model="modalRejectEgar.show" modalAlign="align__flex--center" :title="$t('environmental-management.egar.edit-egar-form.modal-reject-egar.title')" modal-width="460px">
            <template v-slot:modal-close>
                <div @click="modalRejectEgar.show = false">
                    <img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" width="20" height="20" />
                </div>
            </template>

            <template v-slot:modal-body>
                <p>{{$t('environmental-management.egar.edit-egar-form.modal-reject-egar.msg')}}</p>

                <v-text-field
                    filled
                    v-model="modalRejectEgar.obs"
                    :label="$t('environmental-management.egar.edit-egar-form.obs-label')"
                ></v-text-field>
            </template>

            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn text class="danger-button"  @click="modalRejectEgar.show = false">
                        <span style="text-transform: capitalize">{{$t('no')}}</span>
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn text class="primary-button" @click="rejectSend()">
                        <span style="text-transform: capitalize">{{$t('yes')}}</span>
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <!-- Modal Associate Egar. -->
        <base-modal v-model="modalAssociate.show" modalAlign="align__flex--center" :title="$t('environmental-management.egar.edit-egar-form.modal-associate.title')" modal-width="460px">
            <template v-slot:modal-close>
                <div @click="modalAssociate.show = false">
                    <img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" width="20" height="20" />
                </div>
            </template>

            <template v-slot:modal-body>
                <v-text-field
                    filled
                    v-model="modalAssociate.numEgar"
                    :label="$t('environmental-management.egar.edit-egar-form.modal-associate.guide-nbr')"
                ></v-text-field>
            </template>


            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn text class="danger-button"  @click="modalAssociate.show = false">
                        <span style="text-transform: capitalize">{{$t('cancel')}}</span>
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn text class="primary-button" @click="associateSend()">
                        <span style="text-transform: capitalize">{{$t('environmental-management.egar.edit-egar-form.modal-associate.associate-btn')}}</span>
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <!-- Modal Associar Egar. -->
        <base-modal v-model="modalAccept.show" modalAlign="align__flex--center" :title="$t('environmental-management.egar.edit-egar-form.modal-accept.title')" modal-width="460px">
            <template v-slot:modal-close>
                <div @click="modalAccept.show = false">
                    <img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" width="20" height="20" />
                </div>
            </template>

            <template v-slot:modal-body>
                <v-form v-model="modalAccept.validate">
                    <v-col cols="12">
                        <v-menu
                            ref="menuDate"
                            v-model="menuDate"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="modalAccept.date"
                                    :rules="formInputs.default.rules"
                                    :label="$t('environmental-management.egar.edit-egar-form.modal-accept.transporter-date-req')"
                                    persistent-hint
                                    v-bind="attrs"
                                    append-icon="mdi-calendar"
                                    filled
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="modalAccept.date"
                                no-title
                                @input="menuDate = false"
                            >
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    class="primary-button"
                                    @click="menuDate = false"
                                >
                                    {{$t('cancel')}}
                                </v-btn>
                                <v-btn
                                    text
                                    class="primary-button"
                                    @click="$refs.menuDate.save(modalAccept.date)"
                                >
                                    {{$t('ok')}}
                                </v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-col>

                    <v-col cols="12">
                        <v-dialog
                            ref="dialog"
                            v-model="allowableWasteOfTimeModal"
                            :return-value.sync="modalAccept.hours"
                            persistent
                            width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="modalAccept.hours"
                                :label="$t('environmental-management.egar.edit-egar-form.modal-accept.init-hour-transporter-req')"
                                :rules="formInputs.default.rules"
                                append-icon="mdi-clock-time-four-outline"
                                readonly
                                filled
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                            </template>
                            <v-time-picker
                                v-if="allowableWasteOfTimeModal"
                                v-model="modalAccept.hours"
                                full-width
                                format="24hr"
                            >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                class="primary-button"
                                @click="allowableWasteOfTimeModal = false"
                            >
                                {{$t('cancel')}}
                            </v-btn>
                            <v-btn
                                text
                                class="primary-button"
                                @click="$refs.dialog.save(modalAccept.hours)"
                            >
                                {{$t('ok')}}
                            </v-btn>
                            </v-time-picker>
                        </v-dialog>
                    </v-col>
                </v-form>
            </template>

            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn text class="danger-button"  @click="modalAccept.show = false">
                        <span style="text-transform: capitalize">{{$t('cancel')}}</span>
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn text class="primary-button" @click="acceptSend()" :disabled="!modalAccept.validate">
                        <span style="text-transform: capitalize">{{$t('environmental-management.egar.accept')}}</span>
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <!-- Modal Reject correction Egar. -->
        <base-modal v-model="modalRejectCorrection.show" modalAlign="align__flex--center" :title="$t('environmental-management.egar.edit-egar-form.modal-reject-correction.title')" modal-width="460px">
            <template v-slot:modal-close>
                <div @click="modalRejectCorrection.show = false">
                    <img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" width="20" height="20" />
                </div>
            </template>

            <template v-slot:modal-body>
                <p>{{$t('environmental-management.egar.edit-egar-form.modal-reject-correction.msg')}}</p>

                <v-text-field
                    filled
                    v-model="modalRejectCorrection.obs"
                    :label="$t('environmental-management.egar.edit-egar-form.obs-label')"
                ></v-text-field>
            </template>


            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn text class="danger-button"  @click="modalRejectCorrection.show = false">
                        <span style="text-transform: capitalize">{{$t('no')}}</span>
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn text class="primary-button" @click="rejectCorrectionSend()">
                        <span style="text-transform: capitalize">{{$t('yes')}}</span>
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <base-modal v-model="modalEmail.show" :title="$t('environmental-management.egar.edit-egar-form.modal-email.title')" modal-width="560px" >
            <template v-slot:modal-close>
                <div @click="cancelarEmail()">
                    <img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" width="20" height="20" />
                </div>
            </template>

            <template v-slot:modal-body>
                <v-form v-model="modalEmail.isValid">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                :label="$t('environmental-management.egar.edit-egar-form.modal-email.name-label')"
                                v-model="modalEmail.name"
                                :rules="formRules.defaultRules"
                                filled
                                hide-details="auto"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12">
                            <v-text-field
                                :label="$t('environmental-management.egar.edit-egar-form.modal-email.email-label')"
                                v-model="modalEmail.email"
                                :rules="formRules.defaultRules"
                                filled
                                hide-details="auto"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-form>
            </template>

            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn class="danger-button" text @click="cancelarEmail()">
                        {{$t('cancel')}}
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn class="primary-button" text @click="enviarEgar()" :disabled="!modalEmail.isValid">
                        {{$t('send')}}
                    </v-btn>
                </div>
            </template>
        </base-modal>
    </div>
</template>

<script>
    import { GetLerCode, GetOperationCode} from '@services/b2b/environmental-management/EgarService';
    import {
      GetSILiAmbEgar,
      CorrectEgar,
      AnularEgar,
      RejectEgar,
      AssociateEgar,
      AcceptEgar,
      AcceptCorrectionEgar,
      RejectCorrectionEgar,
      SendEmailEgar,
      AuthorizeEgar
      } from '@services/b2b/environmental-management/EgarManagementService';
    import { required } from '@src/utils/validations.js';
    import BaseModal from "@components/shared/widgets/BaseModal.vue";
    import BasePageHeader from "@components/shared/widgets/pages-header/BasePageHeader.vue";

    export default {
        components: {BasePageHeader, BaseModal},
        data(){
            return{
                breadcrumb: [
                    {
                        title: this.$t('environmental-management.title'),
                        routerLinkName: 'environmentalManagement'
                    },
                    {
                        title: this.$t('environmental-management.egar.title'),
                        routerLinkName: 'environmentalManagementEGAR'
                    },
                    {
                        title: ''
                    }
                ],

                modalEmail:{
                    show:false,
                    isValid: false,
                    email: '',
                    name: '',
                    egarNumber: '',
                    egarCode: '',
                    egarLink: ''
                },

                formInputs: {
                    default: {
                        rules: [required]
                    },
                },
                menuDate: false,
                allowableWasteOfTimeModal: false,

                modalAlert: {
                    show: false,
                    noRefresh: false,
                    msg: '',
                },
                modalAnularEgar: {
                    show: false,
                    obs: ''
                },

                modalRejectEgar: {
                    show: false,
                    obs: ''
                },
                modalRejectCorrection: {
                    show: false,
                    obs: ''
                },


                modalAssociate: {
                    show: false,
                    numEgar: ''
                },
                modalAccept: {
                    validate: false,
                    show: false,
                    date: '',
                    hours: ''
                },

                egarNum: '',
                egarCode: '',
                dados: [],
                corrigir: false,
                lerCodes: [],
                operationCodes:[],
                form: {
                    isValid: false,
                    lerCode: null,
                    operationCode: null,
                    qtd: 0
                },
                formInputs: {
                    default: {
                        rules: [required]
                    },
                },
                lerCode: 0,
                formRules: {
                    defaultRules: [required]
                },
                isProducer: false,
            }
        },
        computed:{
            userState() {
                return this.$store.getters['auth/getState'];
            },
        },
        methods:{
            showModalEmail(item){
                this.modalEmail.egarNumber = item.egarNumber
                this.modalEmail.egarCode = item.egarCode
                this.modalEmail.egarLink = item.url
                this.modalEmail.show = true;
            },
            cancelarEmail(){
                this.modalEmail = {
                    show:false,
                    email: '',
                    name: '',
                    egarNumber: '',
                    egarCode: '',
                    egarLink: ''
                }
            },
            enviarEgar(){
                this.modalEmail.show = false;
                const body = {
                    "email": this.modalEmail.email,
                    "name": this.modalEmail.name,
                    "egarNumber": this.modalEmail.egarNumber,
                    "egarCode": this.modalEmail.egarCode,
                    "egarLink": this.modalEmail.egarLink
                }

                this.$store.commit('loadings/setStateLoadingTemplate', true);

                SendEmailEgar(body)
                .then(response => {
                    this.modalEmail = {
                        show:false,
                        email: '',
                        name: '',
                        egarNumber: '',
                        egarCode: '',
                        egarLink: ''
                    }
                    this.modalAlert.msg = this.$t('environmental-management.egar.edit-egar-form.modal-alert.msg1')
                    this.modalAlert.show = true;
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);

                    if(error.response.status == 409){
                        this.modalAlert.msg = error.response.data.errorMessage
                    }else{
                        this.modalAlert.msg = this.$t('environmental-management.egar.edit-egar-form.modal-alert.msg2')
                    }
                    this.modalAlert.show = true;
                    throw new Error('error to get list SendEmailEgar values', error);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                })
            },
            duplicarItem(){
                this.$router.push({name: 'environmentalManagementEGARNew', params: {egar: this.dados, duplica: true}})
            },
            backPage(){
                this.$router.push({name: 'environmentalManagementEGAR'})
            },
            corrigirShow(){
                this.corrigir = true
            },
            corrigirSend(){
                const body ={
                    "interveningNif": this.userState.nif.substr(2),
                    "egarId": {
                        "egarNumber": this.egarNum,
                        "verificationCode": this.egarCode
                    },
                    "correctedData": {
                        "residueLERCode": this.form.lerCode,
                        "operationCode": this.form.operationCode,
                        "quantity": this.form.qtd,
                    },
                    "transportationEndDateTime": this.dados.transporters.transportationStartDateTime,
                    "isProducer": this.isProducer
                }
                if(this.form.isValid){
                    this.$store.commit('loadings/setStateLoadingTemplate', true);

                    CorrectEgar(body)
                        .then(response => {
                            this.modalAlert.msg = this.$t('environmental-management.egar.edit-egar-form.modal-alert.msg3')
                            this.modalAlert.show = true;
                        })
                        .catch(error => {
                            this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);

                            if(error.response.status == 409){
                                this.modalAlert.msg = error.response.data.errorMessage
                            }else{
                                this.modalAlert.msg = this.$t('environmental-management.egar.edit-egar-form.modal-alert.msg4')
                            }
                            this.modalAlert.show = true;
                            throw new Error('error to get list GetSILiAmbEgars values', error);
                        })
                        .finally(() => {
                            this.$store.commit('loadings/setStateLoadingTemplate', false);
                        })
                }
                return false;
            },
            showModalAnular(){
                this.modalAnularEgar.show = true;
            },
            showModalReject(){
                this.modalRejectEgar.show = true;
            },
            showModalAssociate(){
                this.modalAssociate.show = true;
            },
            showModalAccept(){
                this.modalAccept.show = true;
            },
            showModalRejectCorrection(){
                this.modalRejectCorrection.show = true;
            },
            anularSend(){
                this.modalAnularEgar.show = false;
                this.$store.commit('loadings/setStateLoadingTemplate', true);
                const body = {
                    "interveningNif": this.userState.nif.substr(2),
                    "egarId": {
                        "egarNumber": this.egarNum,
                        "verificationCode": this.egarCode
                    },
                    "observations": this.modalAnularEgar.obs,
                    "isProducer": this.isProducer
                }

                AnularEgar(body)
                .then(response => {
                    if(response.data.result){
                        this.modalAlert.msg = this.$t('environmental-management.egar.edit-egar-form.modal-alert.msg5')
                        this.modalAlert.show = true;
                    }else{
                        this.modalAlert.msg = this.$t('environmental-management.egar.edit-egar-form.modal-alert.msg6')
                        this.modalAlert.title = this.$t('heads-up')
                        this.modalAlert.iconName = 'mdi-alert-outline';
                        this.modalAlert.iconColor = 'warning';
                        this.modalAlert.show = true;
                    }
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);

                    if(error.response.status == 409){
                        this.modalAlert.msg = error.response.data.errorMessage
                    }else{
                        this.modalAlert.msg = this.$t('environmental-management.egar.edit-egar-form.modal-alert.msg6')
                    }
                    this.modalAlert.show = true;
                    throw new Error('error to get list AnularEgar values', error);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                })
            },
            rejectSend(){
                this.modalRejectEgar.show = false;
                this.$store.commit('loadings/setStateLoadingTemplate', true);
                const body = {
                    "interveningNif": this.userState.nif.substr(2),
                    "egarId": {
                        "egarNumber": this.egarNum,
                        "verificationCode": this.egarCode
                    },
                    "observations": this.modalRejectEgar.obs,
                    "isProducer": this.isProducer
                }

                RejectEgar(body)
                .then(response => {
                    if(response.data.result){
                        this.modalAlert.msg = this.$t('environmental-management.egar.edit-egar-form.modal-alert.msg7')
                        this.modalAlert.show = true;
                    }else{
                        this.modalAlert.msg = this.$t('environmental-management.egar.edit-egar-form.modal-alert.msg8')
                        this.modalAlert.title = this.$t('heads-up')
                        this.modalAlert.iconName = 'mdi-alert-outline';
                        this.modalAlert.iconColor = 'warning';
                        this.modalAlert.show = true;
                    }
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    if(error.response.status == 409){
                        this.modalAlert.msg = error.response.data.errorMessage
                    }else{
                        this.modalAlert.msg = this.$t('environmental-management.egar.edit-egar-form.modal-alert.msg8')
                    }
                    this.modalAlert.show = true;
                    throw new Error('error to get list RejectEgar values', error);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                })
            },
            associateSend(){
                this.modalAssociate.show = false;
                this.$store.commit('loadings/setStateLoadingTemplate', true);
                const body = {
                    "interveningNif": this.userState.nif.substr(2),
                    "egarId": {
                        "egarNumber": this.egarNum,
                        "verificationCode": this.egarCode
                    },
                    "connectedEgarNumber": this.modalAssociate.numEgar,
                    "isProducer": this.isProducer
                }

                AssociateEgar(body)
                .then(response => {
                    if(response.data.result){
                        this.modalAlert.msg = this.$t('environmental-management.egar.edit-egar-form.modal-alert.msg9')
                        this.modalAlert.show = true;
                    }else{
                        this.modalAlert.msg = this.$t('environmental-management.egar.edit-egar-form.modal-alert.msg10')
                        this.modalAlert.title = this.$t('heads-up')
                        this.modalAlert.iconName = 'mdi-alert-outline';
                        this.modalAlert.iconColor = 'warning';
                        this.modalAlert.show = true;
                    }
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);

                    if(error.response.status == 409){
                        this.modalAlert.msg = error.response.data.errorMessage
                    }else{
                        this.modalAlert.msg = this.$t('environmental-management.egar.edit-egar-form.modal-alert.msg10')
                    }
                    this.modalAlert.show = true;
                    throw new Error('error to get list RejectEgar values', error);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                })
            },
            acceptSend(){
                this.modalAccept.show = false;

                this.$store.commit('loadings/setStateLoadingTemplate', true);
                const body = {
                    "interveningNif": this.userState.nif.substr(2),
                    "egarId": {
                        "egarNumber": this.egarNum,
                        "verificationCode": this.egarCode
                    },
                    "transportationDateTime": new Date().toISOString(),
                    "isProducer": this.isProducer
                }

                AcceptEgar(body)
                .then(response => {
                    if(response.data.result){
                        this.modalAlert.msg = this.$t('environmental-management.egar.edit-egar-form.modal-alert.msg11')
                        this.modalAlert.show = true;
                    }else{
                        this.modalAlert.msg = this.$t('environmental-management.egar.edit-egar-form.modal-alert.msg12')
                        this.modalAlert.title = this.$t('heads-up')
                        this.modalAlert.iconName = 'mdi-alert-outline';
                        this.modalAlert.iconColor = 'warning';
                        this.modalAlert.show = true;
                    }
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    this.modalAlert.msg = this.$t('environmental-management.egar.edit-egar-form.modal-alert.msg12')
                    this.modalAlert.show = true;
                    throw new Error('error to get list RejectEgar values', error);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                })
            },
            acceptCorrectionSend(){
                this.modalAccept.show = false;
                this.$store.commit('loadings/setStateLoadingTemplate', true);
                const body = {
                    "interveningNif": this.isProducer ? this.dados.sender.nif : this.userState.nif.substr(2),
                    "egarId": {
                        "egarNumber": this.egarNum,
                        "verificationCode": this.egarCode
                    },
                    "isProducer": this.isProducer
                }

                AcceptCorrectionEgar(body)
                .then(response => {
                    if(response.data.result){
                        this.modalAlert.msg = this.$t('environmental-management.egar.edit-egar-form.modal-alert.msg13')
                        this.modalAlert.show = true;
                    }else{
                        this.modalAlert.msg = this.$t('environmental-management.egar.edit-egar-form.modal-alert.msg14')
                        this.modalAlert.title = this.$t('heads-up')
                        this.modalAlert.iconName = 'mdi-alert-outline';
                        this.modalAlert.iconColor = 'warning';
                        this.modalAlert.show = true;
                    }
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);

                    if(error.response.status == 409){
                        this.modalAlert.msg = error.response.data.errorMessage
                    }else{
                        this.modalAlert.msg = this.$t('environmental-management.egar.edit-egar-form.modal-alert.msg12')
                    }
                    this.modalAlert.show = true;
                    throw new Error('error to get list AcceptCorrectionEgar values', error);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                })
            },
            rejectCorrectionSend(){
                this.modalAccept.show = false;
                this.$store.commit('loadings/setStateLoadingTemplate', true);
                const body = {
                    "interveningNif": this.isProducer ? this.dados.sender.nif : this.userState.nif.substr(2),
                    "egarId": {
                        "egarNumber": this.egarNum,
                        "verificationCode": this.egarCode
                    },
                    "senderComment": this.modalRejectCorrection.obs,
                    "isProducer": this.isProducer
                }

                RejectCorrectionEgar(body)
                .then(response => {
                    if(response.data.result){
                        this.modalAlert.msg = this.$t('environmental-management.egar.edit-egar-form.modal-alert.msg15')
                        this.modalAlert.show = true;
                    }else{
                        this.modalAlert.msg = this.$t('environmental-management.egar.edit-egar-form.modal-alert.msg6')
                        this.modalAlert.title = this.$t('heads-up')
                        this.modalAlert.iconName = 'mdi-alert-outline';
                        this.modalAlert.iconColor = 'warning';
                        this.modalAlert.show = true;
                    }
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);

                    if(error.response.status == 409){
                        this.modalAlert.msg = error.response.data.errorMessage
                    }else{
                        this.modalAlert.msg = this.$t('environmental-management.egar.edit-egar-form.modal-alert.msg16')
                    }
                    this.modalAlert.show = true;
                    throw new Error('error to get list RejectCorrectionEgar values', error);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                })
            },
            getEgar(){
                this.$store.commit('loadings/setStateLoadingTemplate', true);

                GetSILiAmbEgar(this.egarNum, this.egarCode)
                    .then(response => {
                        if(response.data.result){
                            this.dados = response.data.result

                                this.form.lerCode = +response.data.result.tranportedResidue.residueLerCode

                                this.form.operationCode = response.data.result.tranportedResidue.operationCode
                                this.lerCode = response.data.result.tranportedResidue.residueLerCode
                                this.getLerCodes()

                        }else{
                            this.modalAlert.msg = this.$t('environmental-management.egar.edit-egar-form.modal-alert.msg17')
                            this.modalAlert.show = true;
                        }
                    })
                    .catch(error => {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);

                        if(error.response.status == 409){
                            this.modalAlert.msg = error.response.data.errorMessage
                        }else{
                            this.modalAlert.msg = this.$t('environmental-management.egar.edit-egar-form.modal-alert.msg18')
                        }
                        this.modalAlert.show = true;
                        throw new Error('error to get list GetSILiAmbEgars values', error);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                    })
            },
            getLerCodes(){
                if(this.lerCodes.length == 0){
                    this.$store.commit('loadings/setStateLoadingTemplate', true);

                    return GetLerCode()
                        .then(response => {
                            this.lerCodes = response.data.result
                            var lerCodeId = this.lerCodes.filter(el => el.lerCode == this.lerCode)[0].lerCodeId;
                            //console.log('lerCodeId :>> ', lerCodeId);
                            this.getOperationCodes(lerCodeId)
                        })
                        .catch(error => {
                            this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                            throw new Error('error to get GetLerCode values', error);
                        })
                        .finally(() => {
                            this.$store.commit('loadings/setStateLoadingTemplate', false);
                        })
                }
            },
            getOperationCodes(lerCodeID){
                this.$store.commit('loadings/setStateLoadingTemplate', true);

                return GetOperationCode(lerCodeID)
                    .then(response => {
                        if(response.data.result.length > 0){
                            this.operationCodes = response.data.result
                        }
                    })
                    .catch(error => {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                        throw new Error('error to get GetLerCode values', error);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                    })

            },
            sendAuthorizeEgar() {
              this.$store.commit('loadings/setStateLoadingTemplate', true);
                const body = {
                    "nifInterveniente": this.isProducer ? this.dados.sender.nif : this.userState.nif.substr(2),
                    "idGuia": {
                        "egarNumber": this.egarNum,
                        "verificationCode": this.egarCode
                    },
                }
                AuthorizeEgar(body)
                .then(response => {
                    if(response.data.result){
                        this.modalAlert.msg = this.$t('environmental-management.egar.edit-egar-form.modal-alert.msg19')
                        this.modalAlert.show = true;
                    }else{
                        this.modalAlert.msg = this.$t('environmental-management.egar.edit-egar-form.modal-alert.msg20')
                        this.modalAlert.title = this.$t('heads-up')
                        this.modalAlert.iconName = 'mdi-alert-outline';
                        this.modalAlert.iconColor = 'warning';
                        this.modalAlert.show = true;
                    }
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);

                    if(error.response.status == 409){
                        this.modalAlert.msg = error.response.data.errorMessage
                    } else {
                      this.modalAlert.msg = this.$t('environmental-management.egar.edit-egar-form.modal-alert.msg20')
                    }
                    this.modalAlert.show = true;
                    throw new Error('error to get list AcceptCorrectionEgar values', error);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                })
            }
        },
        created() {
            this.egarNum = this.$route.params.egarNum
            this.egarCode = this.$route.params.egarCode
            this.breadcrumb[2].title = this.$route.params.egarNum

            this.getEgar()

            if(this.$route.name == 'environmentalManagementEGAREditProducer'){
                this.isProducer = true;
            }
        }
    }
</script>

<style lang="scss" scoped>
@import '@sass/_variables.scss';
.btn-close{
    float: right;
    cursor: pointer;
    ::v-deep svg{
        path{
            fill:var(--v-primary-base);
        }
    }
}

.menu-action{
    a{
        color: $grey;
        font-size: 12px;
        ::v-deep svg{
            path{
                fill: $grey;
            }
        }
        &:hover{
            color: var(--v-primary-base);
            ::v-deep svg{
                path{
                    fill: var(--v-primary-base);
                }
            }
        }
    }
}

.title_{
    font-size: 16px;
    margin-bottom: 0;
}
.subTitle{
    font-size: 16px;
    color: $grey;
}


.pendente{
    opacity: 0.5;
    font-weight: 600;
}
.emidita{
    font-weight: 600;
}
.anulada{
    color: red;
    font-weight: 600;
    ::v-deep svg{
        path{
            fill: red;
        }
    }
}
.concluir{
    color: green;
    font-weight: 600;
    ::v-deep svg{
        path{
            fill: green;
        }
    }
}
.corrigir{
    color: rgb(189, 114, 1);
    font-weight: 600;
    ::v-deep svg{
        path{
            fill: rgb(189, 114, 1);
        }
    }
}

.corrigido{
    color: #F59534;
    font-weight: 500;
    ::v-deep svg{
        path{
            fill: #F59534;
        }
    }
}

.div-transp {
    border: 1px solid #ccc;
    padding: 10px;
    border-radius: 5px;
}

.div-produtor{
    padding: 20px;
    background: $grey-light;
}
</style>
